import { IComponent, IOption } from '../../../interfaces';
import BaseMultiSelect from './base-multi-select';
import { useProps } from '../../../hooks/use-props';

export interface IMultiSelectProps {
  id: string;
}

export interface IInternalMultiSelectProps {
  id: string;
  className?: string;
  placeholder?: string;
  label?: string;
  freeSolo?: boolean;
  options: IOption[];
  value: IOption[];
  required?: boolean;
  error?: string;
  disabled?: boolean;
  groupBy?: boolean;
  onSelect: (value: IOption[]) => void;
  onChange?: (value: string) => void;
  maxReached?: boolean;
  warn?: string;
}

interface IMultiSelectAtom extends IComponent {
  options: IOption[];
  value: IOption[];
  answer: IOption[];
  error?: string;
  warn?: string;
  maxReached?: boolean;
}

export const useMultiSelect = (id: string) => {
  const { props, addAnswer, validate } = useProps<IMultiSelectAtom>({ id, initial_state: [] });
  const setValue = (options: IOption[]) => {
    addAnswer({ options });
  };
  return { props, setValue, validate };
};

const MultiSelect = ({ id }: IMultiSelectProps) => {
  const {
    props: { required, error, options, label, show, value },
    setValue,
  } = useMultiSelect(id);

  if (!show || !options) return null;
  return (
    <BaseMultiSelect
      id={id}
      label={label}
      options={options}
      value={value}
      required={required}
      error={error}
      onSelect={(value) => setValue(value)}
    />
  );
};

export default MultiSelect;
